<template>
  <div>
    <!-- 装箱界面 -->
    <el-dialog :title="$t('message.encasementInterface')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1688px" center>
      <div class="content">
        <!-- oneCasePack: '每一箱装箱数', -->
        <div class="head-title">
          <!-- 当前选中箱数： -->
          <span>
            {{ $t("message.selectBoxNum") }}：
            <span class="color" style="margin-right: 70px">{{ selectBox.length }}</span>
          </span>
          <!--选中箱号  -->
          <span>{{ $t("message.selectBoxes") }}：</span>
          <div class="selectBox">
            <el-tooltip class="item" effect="dark" :content="selectBox.join('、')" placement="top-start">
              <span class="color">{{ selectBox.join('、') }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="table">
          <ol>
            <li>
              <el-checkbox v-model="checked" @change="handleALLChange">全选</el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 数量 -->
            <li>{{ $t("message.quantity") }}</li>
            <!-- 仓库数量 -->
            <li class="flex2">{{ $t("message.warehouseNumber") }}</li>
            <!-- 每一箱装箱数 -->
            <li>{{ $t("message.oneCasePack") }}</li>
            <!-- 库存商品使用数量 -->
            <li class="flex2">
              {{ $t("message.quantityOfGoodsUsedInStock") }}
            </li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!-- 选择 -->
            <li>
              <el-checkbox v-model="item.checked" @change="handleCheckedChange"></el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ item.order_detail.order_sn }}</li>
            <li class="flex05">{{ item.order_detail.sorting }}</li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.order_detail.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--数量 -->
            <li>
              <div>
                <!-- 提出数 -->
                <p>{{ $t("message.putForwardNum") }}：{{ item.num }}</p>
                <!-- 待装箱 -->
                <p>
                  {{ $t("message.toEncasement") }}：{{ item.waitFreightNum }}
                </p>
                <!-- 已装箱 -->
                <p>{{ $t("message.boxed") }}：{{ item.hasFreightNum }}</p>
                <!-- 已出货 -->
                <!-- <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p> -->
              </div>
            </li>
            <!-- 仓库数量 -->
            <li class="flex2">
              <div class="template">
                <div class="row" v-for="(items, indexs) in item.wms_stock" :key="indexs">
                  <div class="jy" style="color: #fa5058">
                    JY{{ indexs + 1 }}:{{ items.order_purchase.purchase_no }}
                  </div>
                  <!-- 库位 -->
                  <div class="location">
                    <span>
                      {{ $t("message.location") }}:{{ items.grid_number }}</span>
                    <span>{{ items.not_boxed_stock }}</span>
                  </div>
                </div>
              </div>
            </li>
            <!-- 每一箱装箱数 -->
            <li>
              <el-input v-model="item.encasementNum" type="number" onfocus="this.select()"
                @input="batchMaxItemNum(item, index)"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
            </li>
            <!-- 库存商品使用数量 -->
            <li class="flex2">
              <div class="template">
                <div class="row" v-for="(items, indexs) in item.wms_stock" :key="indexs">
                  <div class="jy" style="color: #fa5058">
                    JY{{ indexs + 1 }}:{{ items.order_purchase.purchase_no }}
                  </div>
                  <!-- 库位 -->
                  <div class="location">
                    <span>
                      {{ $t("message.location") }}:{{ items.grid_number }}</span>
                    <span><el-input v-model="items.surplus" @blur="surplusNum(item, index, indexs)"></el-input></span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      num: "",
      dialogVisible: false,
      list: [],
      porder_sn: this.$route.query.porder_sn,
      checked: false,
    };
  },
  computed: {
    ...mapState({
      selectBox: (state) => state.porderDetail.selectBox,
      boxIds: (state) => state.porderDetail.boxIds,
      isPack: (state) => state.porderDetail.isPack,
    }),
  },
  created() { },
  methods: {
    // 数据预览
    intoBoxPreview() {
      let datas = {
        porderDetailIdS: [],
      };
      this.selectedList.forEach((item) => {
        datas.porderDetailIdS.push(item.id);
      });
      this.checked = false
      this.$api.porderApi.intoBoxPreview(datas).then((res) => {


        res.data.forEach((item, index) => {
          item.checked = false
          // 计算能整数的自动填入装箱数，不能的默认填0
          if (item.waitFreightNum % this.boxIds.length == 0) {
            item.encasementNum = item.waitFreightNum / this.boxIds.length;
          } else {
            item.encasementNum = 0
          }
          item.wms_stock.forEach((items) => {
            items.surplus = 0;
          });

        });
        this.list = res.data;
        this.list.forEach((item, index) => {
          this.maxItemNum(item, index)
        })
      });
    },
    // 保存
    save() {
      let datas = {
        freight_id_set: [],
        list: [],
      };
      this.boxIds.forEach((item) => {
        datas.freight_id_set.push(item);
      });
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].encasementNum == 0 || !this.list[i].encasementNum)
          return this.$message.error("请输入每一箱装箱数");
        let stock = [];
        this.list[i].wms_stock.forEach((item) => {
          stock.push({
            stock_id: item.id,
            num_need: item.surplus,
          });
        });
        datas.list.push({
          per_num: this.list[i].encasementNum,
          porder_detail_id: this.list[i].id,
          stock: stock,
        });
      }
      this.$api.porderApi.intoBoxSubmit(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn, filterByFreightNum: this.isPack });
        this.$parent.selectedList = []
      });
    },
    // 批量计算装箱最大数
    batchMaxItemNum(data, i) {
      if (!data.checked) {
        this.maxItemNum(data, i)
      } else {
        this.list.forEach((item, index) => {
          if (item.checked) {
            item.encasementNum = data.encasementNum
            this.maxItemNum(item, index)
          }
        })
      }
    },
    // 装箱最大数
    maxItemNum(data, i) {
      let encasementNumTotal = data.encasementNum * this.boxIds.length; //箱子数*每箱的数量
      let stockTotal = 0; //待装箱总数
      let wms_stock = this.list[i].wms_stock; //仓库里的商品列表
      //   计算待装箱总数
      wms_stock.forEach((item) => {
        stockTotal += item.not_boxed_stock;
      });
      if (encasementNumTotal > data.waitFreightNum) {
        // console.log(1, encasementNumTotal);
        this.list[i].encasementNum = data.waitFreightNum;
        data.encasementNum = data.waitFreightNum;
        encasementNumTotal = data.encasementNum * this.boxIds.length; //箱子数*每箱的数量
        this.$forceUpdate();
        this.$message.error("装箱数不能大于提出数");
      }
      //   装箱数大于提出待装箱数量
      if (stockTotal - encasementNumTotal < 0) {
        this.$message.error("装箱数大于提出待装箱数量");
        this.list[i].encasementNum = 0;
        wms_stock.forEach(item => {
          item.surplus = 0
        })
      } else {
        // 清0 重新算
        wms_stock.forEach(item => {
          item.surplus = 0
        })
        // 装箱总数分发到仓库使用数量
        for (let i = 0; i < wms_stock.length; i++) {
          //   装箱总数 小于等于 仓库数的情况
          if (encasementNumTotal <= wms_stock[i].not_boxed_stock) {
            wms_stock[i].surplus = encasementNumTotal;
            break
          } else if (encasementNumTotal > wms_stock[i].not_boxed_stock) {
            //
            encasementNumTotal -= wms_stock[i].not_boxed_stock;
            wms_stock[i].surplus = wms_stock[i].not_boxed_stock;
          }
        }
      }
      this.$forceUpdate();
    },
    // 剩余数量
    surplusNum(data, index, indexs) {
      let wms_stock = this.list[index].wms_stock; //仓库里的商品列表
      let wms_stoc_total = 0 // 总取出库存商品数
      if (wms_stock[indexs].surplus > wms_stock[indexs].not_boxed_stock) {
        wms_stock[indexs].surplus = 0
        this.$message.error("库存商品数不能大于仓库数量");
        this.$forceUpdate();
      }
      wms_stock.forEach(item => {
        wms_stoc_total += item.surplus
      })
      // 库存数量总计能不能平均到每箱装进去的数量
      if (wms_stoc_total % this.selectBox.length != 0) {
        this.$message.error("库存商品不能平均装进箱子");
        this.maxItemNum(data, index)
      } else {
        this.list[index].encasementNum = wms_stoc_total / this.selectBox.length
        this.$forceUpdate();
      }
    },
    // 全选
    handleALLChange() {
      this.list.forEach(item => {
        item.checked = this.checked
      })
    },
    handleCheckedChange() {
      this.checked = this.list.every(item => item.checked)
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == true) {
        this.intoBoxPreview();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .head-title {
    height: 56px;
    background: #545467;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    padding: 0 24px;
    line-height: 56px;
    display: flex;
    overflow: hidden;

    .selectBox {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .color {
      color: #f9f871;
    }
  }

  .table {
    margin-top: 20px;

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2.5;
    }

    li {
      margin-right: 5px;

      &:nth-last-child(1) {
        margin: 0;
      }

      /deep/.el-input__inner {
        padding: 0;
        text-align: center;
      }
    }

    .attribute {
      width: 100%;
      text-align: left;
      max-height: 80px;
      background-color: #fff;
      padding: 10px;
    }

    .template {
      width: 100%;

      .row {
        display: flex;
        margin-bottom: 5px;

        &:nth-last-child(1) {
          margin: 0;
        }

        .jy {
          flex: 1;
          margin-right: 5px;
        }

        .location {
          flex: 1.5;
          display: flex;

          span {
            &:nth-child(1) {
              flex: 4;
              margin-right: 5px;
            }

            &:nth-child(2) {
              color: #fa5058;
              flex: 1;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>